import React from "react";
import { LayoutTemplate, Plus } from "lucide-react";
import PageHeader, { PrimaryButton } from "components/ui/PageHeader";

interface WidgetsHeaderProps {
    onAddWidget: () => void;
}

const WidgetsHeader: React.FC<WidgetsHeaderProps> = ({ onAddWidget }) => (
    <PageHeader
        icon={<LayoutTemplate className="w-5 h-5" />}
        iconBg="bg-indigo-50 dark:bg-indigo-900/20"
        iconColor="text-indigo-600 dark:text-indigo-400"
        accentColor="bg-gradient-to-r from-indigo-500 to-violet-500"
        title="Widgets"
        subtitle="Manage website widgets and embedded content"
        actions={
            <PrimaryButton icon={<Plus className="w-4 h-4" />} onClick={onAddWidget}>
                Add Widget
            </PrimaryButton>
        }
    />
);

export default WidgetsHeader;
